//@ts-nocheck
import React from "react";
import clsx from "clsx";
import { IconProps } from "../@types/icon";

const Map = {
  qrcode: "fa-sharp fa-solid fa-qrcode",
  bars: "fa-solid fa-bars",
};
export default function Icon(
  props: IconProps & React.HTMLAttributes<HTMLSpanElement>
) {
  const { name, className, ...other } = props;

  const split = name?.split(" ");
  const iconName = split?.map((item) => `fa-${item}`);

  const iconConfig = _TemplateConfig?.icon;
  const graphic = iconConfig?.graphic ? `fa-${iconConfig?.graphic}` : "fa";
  const family = iconConfig?.family ? `fa-${iconConfig?.family}` : "";

  return (
    <i
      className={clsx("gn-icon",
        Map[name as keyof typeof Map] || `${graphic}  ${family} ${iconName?.join(" ")}`,
        className
      )}
      {...other}
    />
  );
}
